import classNames from 'classnames'
import * as React from 'react'

import useMyId from '../../../hooks/useMyId'
import {useUserDisplayName} from '../../../hooks/useUserDisplayName'
import SvgIcon from '../SvgIcon/SvgIcon'

import type {Props} from './BuildPersonal.types'

import styles from './BuildPersonal.css'

function BuildPersonal({className, personal, userId, user, withIcon}: Props) {
  const myId = useMyId()
  const isMyBuild = userId != null && userId === myId
  const userDisplayName = useUserDisplayName(user, true)

  return personal === true && userDisplayName != null ? (
    <div className={classNames(className, styles.wrapper)}>
      {withIcon === true && (
        <SvgIcon
          icon="user"
          className={classNames(styles.icon, {
            [styles.myBuild]: isMyBuild,
          })}
        />
      )}
      {`Personal build by ${userDisplayName}`}
    </div>
  ) : null
}

BuildPersonal.displayName = 'PersonalBuild'
export default React.memo<Props>(BuildPersonal)
